module.exports = __webpack_public_path__ + "static/media/thigh.b96ddab0.svg";